import * as React from "react";
import Link from "next/link";
import {
  fetchDocuments,
  ICategory,
  IDocument,
} from "@nju/data-access-portal-documents";
import { Heading, Loader, Separator, Text } from "@nju/ui";

interface IExtendedDocument extends IDocument {
  category: ICategory;
}

interface IGroupedCategory {
  [key: string]: IExtendedDocument[];
}

export function DocumentsList() {
  const [state, set] = React.useState<"IDLE" | "LOADING" | "ERROR" | "DONE">(
    "IDLE",
  );
  const [data, setData] = React.useState<IGroupedCategory>();
  const categoryIds = [
    "NJU_NWT_OFFER_INFO_OFFER",
    "NJU_NWT_OFFER_INFO_SYSTEM",
    "NJU_NWT_OFFER_INFO_FAQ",
  ];
  const queryString = categoryIds
    .map(function (id) {
      return `categoryId=${id}`;
    })
    .join("&");

  React.useEffect(() => {
    set("LOADING");

    fetchDocuments({
      query: queryString,
    }).then((result) => {
      if (result.isOk) {
        const mappedResult = result.value.map(function (document) {
          const publishedCategory = document.categories.find(function (
            category,
          ) {
            return category.state === "PUBLISHED";
          });
          return {
            ...document,
            category: publishedCategory,
          };
        }) as IExtendedDocument[];

        // eslint-disable-next-line no-restricted-syntax
        const groupedDocuments = mappedResult.reduce(function (acc, item) {
          const categoryId = item.category?.categoryId;
          if (categoryId) {
            if (!acc[categoryId]) {
              acc[categoryId] = [];
            }
            acc[categoryId].push(item);
          }
          return acc;
        }, {} as IGroupedCategory);

        setData(groupedDocuments);
        set("DONE");
      } else {
        set("ERROR");
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (state === "IDLE" || state === "LOADING") {
    return <Loader className="absolute left-1/2" />;
  }

  return (
    <div className="flex flex-col gap-1">
      <div className="only-mobile:mb-3 mb-5">
        <Heading font="ttfirs" tone="neutral" variant="h2">
          Instrukcje i oferty
        </Heading>
      </div>
      <div className="prose">
        <ul>
          {data && data["NJU_NWT_OFFER_INFO_OFFER"] && (
            <>
              <Text display="block" weight="bold">
                Oferta
              </Text>
              <Separator size="xs" tone="invisible" />
              {data["NJU_NWT_OFFER_INFO_OFFER"].map((element, index) => {
                return (
                  <li key={`${element.title.pl}_${index}`}>
                    <Link
                      href={`https://nju.pl/dokumenty/${element.fileName}`}
                      rel="noreferrer"
                      target="_blank"
                    >
                      <Text size="s" withUnderline={true}>
                        {element.title.pl}
                      </Text>
                    </Link>
                    <Separator size="none" tone="invisible" />
                  </li>
                );
              })}
              <Separator size="xs" tone="invisible" />
            </>
          )}
          {data && data["NJU_NWT_OFFER_INFO_SYSTEM"] && (
            <>
              <Text display="block" weight="bold">
                System
              </Text>
              <Separator size="xxs" tone="invisible" />
              {data["NJU_NWT_OFFER_INFO_SYSTEM"].map((element, index) => {
                return (
                  <li key={`${element.title.pl}_${index}`}>
                    <Link
                      href={`https://nju.pl/dokumenty/${element.fileName}`}
                      rel="noreferrer"
                      target="_blank"
                    >
                      <Text size="s" withUnderline={true}>
                        {element.title.pl}
                      </Text>
                    </Link>
                    <Separator size="none" tone="invisible" />
                  </li>
                );
              })}
              <Separator size="xs" tone="invisible" />
            </>
          )}
          {data && data["NJU_NWT_OFFER_INFO_FAQ"] && (
            <>
              <Text display="block" weight="bold">
                FAQ
              </Text>
              <Separator size="xxs" tone="invisible" />
              {data["NJU_NWT_OFFER_INFO_FAQ"].map((element, index) => {
                return (
                  <li key={`${element.title.pl}_${index}`}>
                    <Link
                      href={`https://nju.pl/dokumenty/${element.fileName}`}
                      rel="noreferrer"
                      target="_blank"
                    >
                      <Text size="s" withUnderline={true}>
                        {element.title.pl}
                      </Text>
                    </Link>
                    <Separator size="none" tone="invisible" />
                  </li>
                );
              })}
            </>
          )}
        </ul>
      </div>
    </div>
  );
}
